'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Space = require('../../Space/src/Space.js');
var Menu_module = require('../styles/Menu.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The Menu component shows a list of actions that user can take
 *
 * @component
 * @example
 * ```jsx
 * <Menu>
 *   <Menu.Item>1 год</Menu.Item>
 *   <Menu.Item>2 года</Menu.Item>
 * </Menu>
 * ```
 */
const Menu = React__namespace.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Menu_module.default);
    const classNames = cx(className, 'container');
    return (React__namespace.createElement(Space.Space, { ref: ref, "data-qa": "Menu", direction: "vertical", size: 0, className: classNames, ...restProps }, children));
});
Menu.defaultProps = {};
Menu.displayName = 'Menu';

exports.Menu = Menu;
//# sourceMappingURL=Menu.js.map
